<template>
	<div class="container-wrap cs_page">
		<customer-top currentTab="inquiry_detail"></customer-top>
		<div class="container-box">
			<h3 class="title mb_20">{{ $t('cs.inquiry.inquiry') }} Detail</h3>
			<div class="input_box">
				<div class="label_text">Inquiry Type</div>
				<div class="reply_box type_02 mb_10">{{ ticketInfo.type_title }}</div>
			</div>
			<div class="input_box">
				<div class="label_text">Title</div>
				<div class="reply_box mb_10">{{ ticketInfo.title }}</div>
			</div>
			<div class="input_box">
				<div class="label_text">Inquiry</div>
				<div class="reply_box type_01 mb_10">
					<p class="mb_0">
						{{ ticketInfo.content }}
					</p>
					<p v-if="ticketInfo.reply" class="answer_area">
						<span class="answer_icon"></span>
						{{ ticketInfo.reply }}
					</p>
				</div>
			</div>
			<div class="button_area">
				<button class="button_bg_blue" @click="goList">
					{{ $t('button.list') }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import { fetchTicket } from '@/api/cs';
import { commonError } from '@/common/dialog';
import CustomerTop from '@/components/User/Cs/CustomerTop.vue';

export default {
	name: 'InquiryDetail',
	components: {
		CustomerTop,
	},
	data() {
		return {
			ticketInfo: {},
		};
	},
	created() {
		this.loadTicket();
	},
	methods: {
		goList() {
			this.$router.push({ name: 'user-inquiry_list' });
		},
		async loadTicket() {
			const ticketSeq = this.$route.query.ticket_seq;
			const { ticket_info } = await fetchTicket(ticketSeq).catch(commonError);
			this.ticketInfo = ticket_info;
		},
	},
};
</script>
